<template>
  <span v-if="code" class="relationship-code-detail">
    Code <code>{{ code }}</code>
    <button
      type="button"
      class="relationship-code-detail__copy"
      :aria-label="copied ? `Copied code ${code}` : `Copy code ${code}`"
      :title="copied ? 'Copied' : 'Copy code'"
      @click.stop="copy">
      <v-icon x-small>{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
    </button>
  </span>
</template>

<script>
const COPIED_FEEDBACK_MS = 1600;

// The raw server code: small, copyable, never the headline (showcase C, "code-detail").
export default {
  name: 'RelationshipCodeDetail',
  props: {
    code: { type: String, default: '' },
  },
  data() {
    return { copied: false, timer: null };
  },
  beforeDestroy() {
    if (this.timer) window.clearTimeout(this.timer);
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.code);
        this.copied = true;
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => { this.copied = false; }, COPIED_FEEDBACK_MS);
      } catch (err) {
        this.$dialog.notify.warning(`Copy was blocked by the browser. Code: ${this.code}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.relationship-code-detail {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-xs);
  color: var(--run-muted-ink, #5c6b66);
  font-size: 11.5px;
  font-weight: 400;
}
.relationship-code-detail code {
  padding: 1px 5px;
  border-radius: var(--ds-radius-sm);
  background: var(--ds-surface-hover);
  color: inherit;
  font-family: var(--ds-font-family-mono);
  font-size: 11px;
  box-shadow: none;
}
.relationship-code-detail__copy {
  display: inline-grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border: 0;
  border-radius: var(--ds-radius-sm);
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.relationship-code-detail__copy .v-icon { color: inherit !important; }
.relationship-code-detail__copy:hover { background: var(--ds-control-hover); }
.relationship-code-detail__copy:focus-visible {
  outline: var(--ds-focus-ring-width) solid var(--ds-focus-ring-color);
  outline-offset: var(--ds-focus-ring-offset);
}
</style>
